<div class="relative full-height">
    <ig-image #imgComp [imageUrl]="currentImage" [alt]="alt"></ig-image>
    <div tabindex="0" *ngIf="images&&images.length>1&&showingCount>1" class="img-viewer-pointer" (click)="previous()"
         (keypress)="onPreviousKeyPress($event)" [class.img-viewer-no-more]="!hasPrevious">
        <
    </div>
    <div tabindex="0" *ngIf="images&&images.length>1&&showingCount>1" class="img-viewer-pointer" (click)="next()"
         (keypress)="onNextKeyPress($event)" style="right:0;left:auto" [class.img-viewer-no-more]="!hasNext">
        >
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.viewer/image.viewer.component.html